import { FileFormat } from '../../shared/types/resultsDownload';

export const fileFormatsResultsDownload = [
  FileFormat.fastaRepresentative,
  FileFormat.tsv,
  FileFormat.json,
  FileFormat.excel,
  FileFormat.list,
];

export const fileFormatEntryDownload = [
  FileFormat.fastaRepresentative,
  FileFormat.json,
  FileFormat.xml,
  FileFormat.rdfXml,
  FileFormat.list,
];
